import { render, staticRenderFns } from "./regresar-button.vue?vue&type=template&id=d4ef1120&scoped=true&"
import script from "./regresar-button.component.ts?vue&type=script&lang=ts&"
export * from "./regresar-button.component.ts?vue&type=script&lang=ts&"
import style0 from "./regresar-button.vue?vue&type=style&index=0&id=d4ef1120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ef1120",
  null
  
)

export default component.exports